export default "__VITE_ASSET__ificOFbx__"